module.exports = __webpack_public_path__ + "img/emoji_80.e65b8df1.png";